import { type_of_use_category_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateTypeOfUseCategoryEnum = (enumValue: type_of_use_category_enum) => {
  switch (enumValue) {
    case type_of_use_category_enum.ACCOMMODATION_AND_CATERING:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-ACCOMMODATION_AND_CATERING" />;
    case type_of_use_category_enum.CARE:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-CARE" />;
    case type_of_use_category_enum.ADMINISTRATION:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-ADMINISTRATION" />;
    case type_of_use_category_enum.RESEARCH:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-RESEARCH" />;
    case type_of_use_category_enum.PRODUCTION_AND_OPERATIONS:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-PRODUCTION_AND_OPERATIONS" />;
    case type_of_use_category_enum.TECHNICAL_INFRASTRUCTURE:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-TECHNICAL_INFRASTRUCTURE" />;
    case type_of_use_category_enum.HEALTHCARE:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-HEALTHCARE" />;
    case type_of_use_category_enum.CULTURE_AND_LEISURE:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-CULTURE_AND_LEISURE" />;
    case type_of_use_category_enum.RETAIL:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-RETAIL" />;
    case type_of_use_category_enum.TRANSPORT:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-TRANSPORT" />;
    case type_of_use_category_enum.SPORTS:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-SPORTS" />;
    case type_of_use_category_enum.RESIDENTIAL:
      return <Trans i18nKey="Enum_TypeOfUseCategoryEnum-RESIDENTIAL" />;
  }
};

export const translateTypeOfUseCategoryEnum_dynamic = (enumValue: type_of_use_category_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case type_of_use_category_enum.ACCOMMODATION_AND_CATERING:
      return t('Enum_TypeOfUseCategoryEnum-ACCOMMODATION_AND_CATERING');
    case type_of_use_category_enum.CARE:
      return t('Enum_TypeOfUseCategoryEnum-CARE');
    case type_of_use_category_enum.ADMINISTRATION:
      return t('Enum_TypeOfUseCategoryEnum-ADMINISTRATION');
    case type_of_use_category_enum.RESEARCH:
      return t('Enum_TypeOfUseCategoryEnum-RESEARCH');
    case type_of_use_category_enum.PRODUCTION_AND_OPERATIONS:
      return t('Enum_TypeOfUseCategoryEnum-PRODUCTION_AND_OPERATIONS');
    case type_of_use_category_enum.TECHNICAL_INFRASTRUCTURE:
      return t('Enum_TypeOfUseCategoryEnum-TECHNICAL_INFRASTRUCTURE');
    case type_of_use_category_enum.HEALTHCARE:
      return t('Enum_TypeOfUseCategoryEnum-HEALTHCARE');
    case type_of_use_category_enum.CULTURE_AND_LEISURE:
      return t('Enum_TypeOfUseCategoryEnum-CULTURE_AND_LEISURE');
    case type_of_use_category_enum.RETAIL:
      return t('Enum_TypeOfUseCategoryEnum-RETAIL');
    case type_of_use_category_enum.TRANSPORT:
      return t('Enum_TypeOfUseCategoryEnum-TRANSPORT');
    case type_of_use_category_enum.SPORTS:
      return t('Enum_TypeOfUseCategoryEnum-SPORTS');
    case type_of_use_category_enum.RESIDENTIAL:
      return t('Enum_TypeOfUseCategoryEnum-RESIDENTIAL');
  }
};
